var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestore = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15 12.981 12.981 15 10.5 15C8.78 15 7.23597 14.042 6.46997 12.5C6.34797 12.253 6.44904 11.9531 6.69604 11.8301C6.94104 11.7081 7.24294 11.8069 7.36694 12.0559C7.96294 13.2549 9.16298 14 10.501 14C12.431 14 14.001 12.43 14.001 10.5C14.001 8.57 12.431 7 10.501 7C9.27198 7 8.15798 7.65099 7.53198 8.66699H8.72412C9.00012 8.66699 9.22412 8.89099 9.22412 9.16699C9.22412 9.44299 9.00012 9.66699 8.72412 9.66699H6.5C6.224 9.66699 6 9.44299 6 9.16699V6.94507C6 6.66907 6.224 6.44507 6.5 6.44507C6.776 6.44507 7 6.66907 7 6.94507V7.68506C7.837 6.64506 9.112 6 10.5 6C12.981 6 15 8.019 15 10.5ZM21 10.5C21 16.29 16.29 21 10.5 21C4.71 21 0 16.29 0 10.5C0 4.71 4.71 0 10.5 0C16.29 0 21 4.71 21 10.5ZM20 10.5C20 5.262 15.738 1 10.5 1C5.262 1 1 5.262 1 10.5C1 15.738 5.262 20 10.5 20C15.738 20 20 15.738 20 10.5Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestore);
export default ForwardRef;